import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  alignCenter: {
    alignItems: 'center',
  },
  alignEnd: {
    alignItems: 'flex-end',
  },
  bold: {
    fontFamily: 'Helvetica-Bold',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
  },
  fullRow: {
    margin: 10,
    paddingLeft: 10,
    paddingRight: 10,
    flexGrow: 1,
  },
  gap4: {
    gap: 4,
  },
  gap10: {
    gap: 10,
  },
  halfRow: {
    margin: 10,
    paddingLeft: 10,
    paddingRight: 10,
    flexGrow: 1,
    width: '50%',
  },
  highlight: {
    backgroundColor: '#ffff00',
  },
  italic: {
    fontStyle: 'italic',
  },
  justifyBetween: {
    justifyContent: 'space-between',
  },
  leftColumnWrapper: {
    minWidth: '33%',
    alignItems: 'flex-end',
    gap: 36,
    justifyContent: 'space-between',
  },
  link: {
    fontSize: '8px',
    marginTop: 8,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
  },
  logo: {
    width: '104px',
    marginBottom: 8,
    objectFit: 'scale-down',
  },
  maxWidthFull: {
    maxWidth: '100%',
  },
  paddedBottom: {
    paddingBottom: 5,
  },
  page: {
    display: 'flex',
    backgroundColor: '#ffffff',
    padding: 16,
    fontSize: '10px',
    fontFamily: 'Helvetica',
  },
  quoteNumber: {
    fontSize: '14px',
    marginBottom: 8,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  section: {
    maxWidth: '33%',
    margin: 10,
    paddingLeft: 10,
    paddingRight: 10,
    flexGrow: 1,
  },
  sectionHalf: {
    maxWidth: '50%',
    margin: 10,
    paddingLeft: 10,
    paddingRight: 10,
    flexGrow: 1,
  },
  sectionRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  textCenter: {
    textAlign: 'center',
  },
  textRight: {
    textAlign: 'right',
  },
  textLarge: {
    fontSize: '14px',
  },
  textReverse: {
    backgroundColor: '#000000',
    color: '#ffffff',
    marginBottom: '1px',
    paddingLeft: '1px',
    paddingRight: '1px',
  },
  textSmall: {
    fontSize: '8px',
  },
  underline: {
    textDecoration: 'underline',
  },
  uppercase: {
    textTransform: 'uppercase',
  },
  widthFull: {
    width: '100%',
  },
  wrapper: {
    borderTopWidth: '1px',
    borderTopColor: '#000000',
    borderTopStyle: 'dashed',
    padding: 10,
  },
});
